export default "__VITE_ASSET__C_e3frqi__"